function Button(props) {
	return (<button className={"rounded border px-4 py-1 my-2 mx-1 hover:bg-secondary hover:text-black " + props.className} onClick={props.onClick}>
		{props.children}
	</button>);
}

export default Button;
